var scrollThrottle = false;
var scrollThrottleTime = 250;
const touchThrottleTime = 300;
const zSlider = document.querySelector(".z-slider");
const blocks = zSlider.querySelectorAll(".z-slider-block");
let activeBlock = blocks[0];
var previousBlock = null;
const root = document.documentElement;
const defaultFontColor =
  getComputedStyle(root).getPropertyValue("--color-foreground");
var dragDirection = "";
var distanceFromInitial = 0;
var autoPlay = zSlider.dataset.auto;
const autoPlayInterval = zSlider.dataset.interval;
const overlay = zSlider.querySelector(".z-overlay");
var overlayText = zSlider.querySelector(".z-overlay-text");
var overlayButton = zSlider.querySelector(".z-overlay-button");
var blockScrollAmount = 0;

// Check active block for overlay data and font color
adjustOverlay(activeBlock);
adjustColor(activeBlock);

var lastScrollTime = 0;
var totalDeltaY = 0;
var isWheelEventAllowed = true;
if (zSlider && blocks.length) {
  // Wheel scroll - both desktop and laptop trackpad
  zSlider.addEventListener("wheel", (e) => {
    e.preventDefault();
    if (!isWheelEventAllowed) {
      if (timeoutId) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
          isWheelEventAllowed = true;
        }, 50);
      }
      return;
    }
    isWheelEventAllowed = false;

    timeoutId = setTimeout(() => {
      isWheelEventAllowed = true;
    }, 50);
    if (!scrollThrottle && blockScrollAmount < 2) {
      let activeIndex = Array.from(blocks).indexOf(activeBlock);
      if (e.deltaY > 0 && activeIndex < blocks.length - 1) {
        // Scroll down
        setThrottleTimeout(scrollThrottleTime);
        const nextBlock = blocks[activeIndex + 1];
        scrollDown(nextBlock);
        autoPlay = false;
      } else if (e.deltaY < 0 && activeIndex > 0) {
        // Scroll up
        setThrottleTimeout(scrollThrottleTime);
        const nextBlock = blocks[activeIndex - 1];
        scrollUp(nextBlock);
        autoPlay = false;
      }
    }
  });

  // Drag & touch
  let isDragging = false;
  let startY;
  let initialMouseY;

  zSlider.addEventListener("mousedown", startDrag);
  zSlider.addEventListener("touchstart", startDrag);

  document.addEventListener("mousemove", handleDrag);
  document.addEventListener("touchmove", handleDrag);

  document.addEventListener("mouseup", endDrag);
  document.addEventListener("touchend", endDrag);

  function startDrag(e) {
    isDragging = true;
    startY = e.type === "mousedown" ? e.clientY : e.touches[0].clientY;
    initialMouseY = startY;
    zSlider.style.cursor = "grabbing";
  }

  function handleDrag(e) {
    if (!isDragging) return;
    const clientY = e.type === "mousemove" ? e.clientY : e.touches[0].clientY;
    const deltaY = clientY - startY;
    dragDirection = deltaY < 0 ? "Down" : "Up";
    distanceFromInitial = Math.abs(clientY - initialMouseY);
  }

  function endDrag(e) {
    // menu open fix
    const menuOpen = document.querySelector(
      ".menu-drawer-container.menu-opening"
    );
    if (
      distanceFromInitial < 50 ||
      scrollThrottle ||
      blockScrollAmount === 2 ||
      menuOpen
    ) {
      return;
    }
    let activeIndex = Array.from(blocks).indexOf(activeBlock);
    isDragging = false;
    zSlider.style.cursor = "default";
    setThrottleTimeout(touchThrottleTime);
    if (dragDirection === "Up" && activeIndex > 0) {
      const nextBlock = blocks[activeIndex - 1];
      scrollUp(nextBlock);
      autoPlay = false;
    } else if (dragDirection === "Down" && activeIndex < blocks.length - 1) {
      const nextBlock = blocks[activeIndex + 1];
      scrollDown(nextBlock);
      autoPlay = false;
    }
  }
}

// Auto play
if (autoPlay) {
  setInterval(() => {
    if (!autoPlay) {
      return;
    }
    let activeIndex = Array.from(blocks).indexOf(activeBlock);
    if (activeIndex === blocks.length - 1) {
      // reset position
      blocks.forEach((block) => {
        block.style.transform = "translateY(100%)";
      });
      scrollDown(blocks[0]);
    } else {
      const nextBlock = blocks[activeIndex + 1];
      scrollDown(nextBlock);
    }
  }, autoPlayInterval);
}

function adjustBlock(nextBlock) {
  if (previousBlock != nextBlock) {
    blockScrollAmount++;
    setTimeout(() => {
      blockScrollAmount--;
    }, 500);
  }
  adjustOverlay(nextBlock);
  adjustColor(nextBlock);
  activeBlock.classList.remove("active");
  previousBlock = activeBlock;
  activeBlock = nextBlock;
  nextBlock.classList.add("active");
  nextBlock.style.transform = "translateY(0)";
}

function scrollDown(nextBlock) {
  adjustBlock(nextBlock);
}

function scrollUp(nextBlock) {
  activeBlock.style.transform = "translateY(100%)";
  adjustBlock(nextBlock);
}

function adjustOverlay(nextBlock) {
    let x = nextBlock.dataset.overlayPositionX;
    let y = nextBlock.dataset.overlayPositionY;
    let previousX = activeBlock.dataset.overlayPositionX;
    let previousY = activeBlock.dataset.overlayPositionY;
    console.log(x, y, previousX, previousY);

    if (x != previousX || y != previousY) {
      overlay.classList.add("transition");
      setTimeout(() => {   
        overlay.style.top = y;
        overlay.style.left = x;
        overlay.classList.remove("transition");
        changeOverlayValues(nextBlock);
      }, 500);
    }
    else {
      changeOverlayValues(nextBlock);
    }
  }
  
  function changeOverlayValues (nextBlock) {
    if (nextBlock.dataset.overlayText) {
      // Overlay Text
      overlayText.innerHTML = nextBlock.dataset.overlayText;
      overlayText.style.color = nextBlock.dataset.overlayTextColor;
      overlayText.dataset.show = nextBlock.dataset.overlayTextShow;
  
      overlayText.classList.add("active");
  
      // Overlay Text Link
      if (nextBlock.dataset.overlayTextLink) {
        overlayText.href = nextBlock.dataset.overlayTextLink;
      } else {
        overlayText.href = "#";
      }
    } else {
      // Remove Overlay Text and Button
      overlayText.classList.remove("active");
      overlayButton.classList.remove("active");
    }
  
    if (nextBlock.dataset.overlayButtonLabel) {
      // Overlay Button
      overlayButton.dataset.show = nextBlock.dataset.overlayButtonShow;
      const anchor = overlayButton.querySelector("a");
      anchor.innerHTML = nextBlock.dataset.overlayButtonLabel;
      anchor.href = nextBlock.dataset.overlayButtonLink;
  
      // Button Style
      if (
        nextBlock.dataset.overlayButtonStyle === "secondary" &&
        anchor.classList.contains("button--primary")
      ) {
        anchor.classList.remove("button--primary");
        anchor.classList.add("button--secondary");
      } else if (
        nextBlock.dataset.overlayButtonStyle === "primary" &&
        anchor.classList.contains("button--secondary")
      ) {
        anchor.classList.remove("button--secondary");
        anchor.classList.add("button--primary");
      }
  
      overlayButton.classList.add("active");
    } else {
      // Remove Overlay Button
      overlayButton.classList.remove("active");
    }
};

function adjustColor(nextBlock) {
  if (nextBlock.dataset.fontColor) {
    const rgbObject = hexToRgb(nextBlock.dataset.fontColor);
    const cssColor = rgbObjectToCss(rgbObject);
    setFontColor(cssColor);
  } else {
    setFontColor(defaultFontColor);
  }
}

function setFontColor(fontColor) {
  const element = document.querySelector(".color-background-1");
  element.style.setProperty(
    "--color-foreground",
    fontColor || defaultFontColor
  );
}

function setThrottleTimeout(time) {
  scrollThrottle = true;
  setTimeout(() => {
    scrollThrottle = false;
  }, time);
}

function hexToRgb(hex) {
  // Remove the # symbol if it's present
  hex = hex.replace("#", "");

  // Expand shorthand hex to full six-digit format
  if (hex.length === 3) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }

  // Parse the hex values for red, green, and blue
  var r = parseInt(hex.substring(0, 2), 16);
  var g = parseInt(hex.substring(2, 4), 16);
  var b = parseInt(hex.substring(4, 6), 16);

  // Return the RGB values as an object
  return { r, g, b };
}

function rgbObjectToCss(rgb) {
  return `${rgb.r}, ${rgb.g}, ${rgb.b}`;
}
